import { styled } from '@mui/material/styles';
import { Box, IconButton, Typography } from "@mui/material";

import { APP_BAR_HEIGHT } from '../sticky-nav/sticky-nav.const';

export const StyledImage = styled('img')({
  display: 'block',
  margin: '0 auto',
  objectFit: 'cover',
  minHeight: `calc(100vh - ${APP_BAR_HEIGHT}px)`,
  overflow: 'hidden',
});

export const StyledBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  height: `calc(100vh - ${APP_BAR_HEIGHT}px)`,
  overflow: 'hidden',
});

export const StyledTextOverlayBox = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  padding: '32px 24px',
  pointerEvents: 'none',
});

export const StyledTextOverlayTypography = styled(Typography)({
  color: 'white',
  fontSize: '1.1rem',
  fontWeight: 600,
  textOrientation: 'mixed',
  writingMode: 'sideways-lr',
  textTransform: 'uppercase',
  marginRight: '8px',
  pointerEvents: 'auto',
  fontFamily: 'Silka, sans-serif',
  'a': {
    color: 'white',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
});

export const StyledFooterOverlayBox = styled(Box)({
  position: 'absolute',
  bottom: 0,
  right: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'flex-end',
  padding: '32px 24px',
  pointerEvents: 'none',
});

export const StyledFooterOverlayTypography = styled(Typography)({
  color: 'white',
  fontSize: '0.9rem',
  fontWeight: 600,
  textOrientation: 'mixed',
  writingMode: 'sideways-lr',
  textTransform: 'uppercase',
  'a': {
    color: 'white',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  pointerEvents: 'auto',
  fontFamily: 'Silka, sans-serif',
});

export const StyledArrowOverlayBox = styled(Box)({
  position: 'absolute',
  bottom: 0,
  right: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-end',
  padding: '32px 24px',
  pointerEvents: 'none',
});

export const StyledIconButton = styled(IconButton)({
  color: 'white',
  fontSize: '1.5rem',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
  },
  '&:active': {
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
  },
  margin: '0 8px',
  padding: '8px',
  borderRadius: '50%',
  transition: 'background-color 0.3s ease',
  pointerEvents: 'auto',
});
